var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 0.666016C10.6088 0.666016 11.0329 0.841736 11.3455 1.1543C11.6579 1.46684 11.8337 1.89106 11.8337 2.33301V15.666C11.8337 16.108 11.658 16.5322 11.3455 16.8447C11.0329 17.1573 10.6088 17.333 10.1667 17.333H1.83374C1.39179 17.333 0.967574 17.1572 0.655029 16.8447C0.342469 16.5322 0.166748 16.108 0.166748 15.666V2.33301C0.166748 1.89098 0.342469 1.46686 0.655029 1.1543C0.96759 0.841736 1.39171 0.666016 1.83374 0.666016H10.1667ZM1.83374 15.666H3.49976V13.999H1.83374V15.666ZM5.16675 15.666H6.83374V13.999H5.16675V15.666ZM8.49976 15.666H10.1667V13.999H8.49976V15.666ZM1.83374 12.333H3.49976V10.666H1.83374V12.333ZM5.16675 12.333H6.83374V10.666H5.16675V12.333ZM8.49976 12.333H10.1667V10.666H8.49976V12.333ZM1.83374 8.99902H3.49976V7.33301H1.83374V8.99902ZM5.16675 8.99902H6.83374V7.33301H5.16675V8.99902ZM8.49976 8.99902H10.1667V7.33301H8.49976V8.99902ZM1.83374 5.66602H10.1667V2.33301H1.83374V5.66602Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.e370a5781b5e3c385a0e4016df3f1a2a.svg";
export { ForwardRef as ReactComponent };